import { apiGetService } from './baseApi.service';

export default function stateSearch(stateIDs) {
  return (async () => {
    const url = `/api/state/getRowsForStates?stateNodeIDs=${stateIDs.join('&stateNodeIDs=')}`;

    return apiGetService(url);
  })();
}
